(function ($) {
	const $window = $(window);
	const $subnav = $('.js-sub-nav');

	const $subnavLinks = $subnav.find('a');
	let currentItemId = null;
	let $lines = null;

	// get our anchors
	const $anchors = $subnavLinks.map(function () {
		const $link = $(this);
		const id = $link.attr('href').replace('#', '');
		const $target = document.getElementById(id);

		if ($target) {
			return $($target);
		}
	});

	function debounce(func, wait, immediate) {
		let timeout;

		return function () {
			let context = this,
				args = arguments;
			let later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			let callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	}

	if ($anchors.length === 0) {
		return;
	}

	let $anchorLine = null;

	// on dom ready
	document.addEventListener('DOMContentLoaded', init);

	// on load
	window.addEventListener('load', function () {
		// make sure the lines are drawn correctly
		// even after loading images or anything which will change the height of the page
		this.setTimeout(setLineCoordinates, 300);
	});

	function init() {
		// draw a line between each anchor
		$anchorLine = $('<div class="anchor-line" aria-hidden="true"></div>');
		$('body').append($anchorLine);
		buildLinesBetweenAnchors();
		setLineCoordinates();
		startTicking();

		// on resize, redraw the lines
		$window.on(
			'resize',
			debounce(function () {
				setLineCoordinates();
			}, 300),
		);
	}

	function buildLinesBetweenAnchors() {
		// remove any children in $anchorLine
		$anchorLine.empty();

		// add a line between each anchor
		$anchors.each(function (index, anchor) {
			const $line = $('<div class="anchor-line__section"></div>');
			$line.data('target', $(anchor));
			$line.data('trigger', $subnavLinks[index]);
			$anchorLine.append($line);
		});

		$lines = $anchorLine.find('.anchor-line__section');
	}

	function setLineCoordinates() {
		// remove any children in $anchorLine
		const currentY = window.scrollY;
		let $stickyAncestor = null;
		let $stickyAncestorNext = null;
		let $this = null;
		let $anchor = null;
		let $nextAnchor = null;
		let isFinal = false;

		$lines.each(function (index) {
			$this = $(this);
			$anchor = $this.data('target');
			$nextAnchor = null;
			isFinal = false;

			$stickyAncestor = null;
			$stickyAncestorNext = null;

			if ($anchors[index + 1]) {
				$nextAnchor = $($anchors[index + 1]);
			} else {
				// this is the final item so we will find its closest .wp-block-columns, wp-block-cover, .entry-content and use the bottom position of that
				$nextAnchor = $anchor.closest('.wp-block-columns, .wp-block-cover, .entry-content');
				isFinal = true;
			}

			// if $anchor or $nextAnchor are position: sticky, get the top of their parent
			if ($anchor.hasClass('is-style-sticky')) {
				$stickyAncestor = $anchor;
			} else {
				$stickyAncestor = $anchor.closest('.is-style-sticky');
			}

			if ($nextAnchor.hasClass('is-style-sticky')) {
				$stickyAncestorNext = $nextAnchor;
			} else {
				$stickyAncestorNext = $nextAnchor.closest('.is-style-sticky');
			}

			if ($stickyAncestor.length) {
				$stickyAncestor.removeClass('is-style-sticky');
			}

			if ($stickyAncestorNext.length) {
				$stickyAncestorNext.removeClass('is-style-sticky');
			}

			// top is the top of the previous anchor from the top of the document
			const top = $anchor[0].getBoundingClientRect().top + currentY;
			// bottom is the bottom of the previous anchor from the top of the document
			const bottom = isFinal
				? $nextAnchor[0].getBoundingClientRect().bottom + currentY
				: $nextAnchor[0].getBoundingClientRect().top + currentY;

			const height = bottom - top;

			if ($stickyAncestor.length) {
				$stickyAncestor.addClass('is-style-sticky');
			}

			if ($stickyAncestorNext.length) {
				$stickyAncestorNext.addClass('is-style-sticky');
			}

			$this.css({
				background: index % 2 === 0 ? 'red' : 'blue',
				top: top,
				height: height,
				left: index % 2 === 0 ? '0' : '10px',
			});
		});
	}

	let ticking = false;
	let lastScrollY = 0;

	function startTicking() {
		$window.on('scroll', function () {
			if (!ticking && lastScrollY !== window.scrollY) {
				lastScrollY = window.scrollY;

				window.requestAnimationFrame(function () {
					updateLines(lastScrollY);
					ticking = false;
				});
			}
			ticking = true;
		});
	}

	function updateLines(scrollY) {
		const viewportCenter = scrollY + window.innerHeight / 2;
		const rectSubnav = $subnav[0].getBoundingClientRect();
		const navCenter = rectSubnav.left + rectSubnav.width / 2;
		let maxShowing = 0;
		let $toHighlight = null;

		$lines.each(function (index) {
			const $line = $(this);
			// calculate what % of the line is above the center of the viewport
			const top = $line.position().top;
			const height = $line.height();
			const bottom = top + height;

			const $trigger = $line.data('trigger');
			const percentage = Math.max(Math.min((viewportCenter - top) / height, 1), 0);

			if (percentage > maxShowing) {
				$toHighlight = $trigger;
			}

			$trigger.style.setProperty('--complete', percentage);

			if (bottom < viewportCenter) {
				// line is above the viewport center
				$trigger.classList.add('highlighted');
			} else if (top < viewportCenter && bottom > viewportCenter) {
				// if the line is in the viewport
				if (currentItemId !== index) {
					currentItemId = index;
					// $trigger.classList.add('selected');
					$trigger.classList.remove('highlighted');
					$subnavLinks.removeClass('current');
					$trigger.classList.add('current');

					// center $trigger by scrolling to half its width
					const rectTrigger = $trigger.getBoundingClientRect();
					const centerRect = rectTrigger.left + rectTrigger.width / 2;

					const scrollX = $subnav[0].scrollLeft;
					const scrollLeft = centerRect - navCenter + scrollX;

					$subnav.animate(
						{
							scrollLeft,
						},
						400,
					);
				}
			} else {
				// remove le highlight
				$trigger.classList.remove('selected');
				$trigger.classList.remove('highlighted');
			}
		});

		if ($toHighlight) {
			$toHighlight.classList.add('selected');
		}
	}
})(jQuery);
